import React from 'react'
import './About.css'

const valuesData = [
  {
    title: "Innovation",
    description: "Constantly exploring new digital tactics to put you ahead of your competition."
  },
  {
    title: "Integrity",
    description: "Honest communication and trustworthy results are at the heart of everything we do."
  },
  {
    title: "Collaboration",
    description: "Your brand’s vision guides our strategy. Partnership is key."
  },
  {
    title: "Excellence",
    description: "Delivering high-quality campaigns with attention to detail and dedication."
  },
  {
    title: "Learning",
    description: "The digital world moves fast; we’re always evolving to serve you better."
  }
];

const OurValue = () => {
  return (
    <div className='backdiv'>
      <h2 className='main_heading'>OUR CORE VALUES</h2>

      <div className='our_value_grid'>
     
        {valuesData.map((item, index) => (
          <div key={index} className='value_card'>
            <div>
            <div className='value_title'>{item.title}</div>
            <div className='value_desc'>{item.description}</div>
            </div>
          </div>
        ))}
        </div>
      </div>
   
  );
};

export default OurValue;
